/*
 * WHERE A CANVAS FINDS WHAT ITS CALLER DID NOT PASS — the tenant (time zone, location), the
 * weather at a location and the tenant's menu. The console provides its API-backed source
 * (`liveData.ts`, through the signed-in fetch store) for the whole app in `main.ts`; the
 * screen player provides none: it passes all of them itself, and its bundle must not carry the
 * console's stores and router (`src/player/`).
 */
import type { InjectionKey } from 'vue'

import type { Location, Menu, TenantInfo, Weather } from '@/design/types'

export interface CanvasDataSource {
    /** Asks for the tenant once per page (a side effect). */
    loadTenantInfo: (tenantId: string) => void
    /** The tenant once asked; null before that. */
    tenantInfo:     (tenantId: string) => TenantInfo | null
    /** Asks for the weather at a location unless a fresh answer is there (a side effect). */
    requestWeather: (tenantId: string, loc: Location) => void
    /** The last known weather at a location. */
    weatherAt:      (tenantId: string, loc: Location) => Weather | null
    /** Asks for the tenant's menu once per page (a side effect). */
    loadMenu:       (tenantId: string) => void
    /** The tenant's menu: undefined while asked for, null when there is none. */
    menuOf:         (tenantId: string) => Menu | null | undefined
}

export const CANVAS_DATA: InjectionKey<CanvasDataSource> = Symbol('canvas-data')
